import { render, staticRenderFns } from "./VerificationsWorkspace.vue?vue&type=template&id=0408d854&scoped=true&"
import script from "./VerificationsWorkspace.vue?vue&type=script&lang=js&"
export * from "./VerificationsWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./VerificationsWorkspace.vue?vue&type=style&index=0&id=0408d854&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0408d854",
  null
  
)

export default component.exports